import React from "react";
import "./Basket_crane_rental.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Hourly_Lifting_Basket_Rental() {
  return (
    <div className="Crane_work_nationwide-page">

      {/* =====================================================
          HERO - כותרת עליונה
      ===================================================== */}

      <div className="Basket_crane_rental-hero">

        <div className="Basket_crane_rental-overlay">
          <h1>השכרת סל הרמה לפי שעה</h1>
        </div>

      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              השכרת סל הרמה לפי שעה
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/8.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי השכרת סל ההרמה לפי שעה של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            השכרת סל הרמה לפי שעה מאפשרת לבצע עבודות בגובה
            בצורה נוחה ויעילה ובהתאם לצורכי העבודה. נצר הובלות
            ומנופים מספקת שירותי השכרת סל הרמה לקבלנים, חברות,
            עסקים, אנשי מקצוע ולקוחות פרטיים, בהתאם לסוג העבודה,
            לגובה הנדרש ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/15.jpeg"
                alt="השכרת סל הרמה לפי שעה"
              />
            </div>

            <div className="text-box">

              <p>
                השכרת סל הרמה לפי שעה דורשת התאמה בין סוג העבודה,
                גובה העבודה, תנאי השטח ומיקום העבודה. לפני ביצוע
                העבודה חשוב לבחון את הגובה הנדרש, אזור העבודה,
                תנאי הגישה והאפשרות להציב את הציוד במקום המתאים.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות לעבודות בגובה
                באמצעות סל הרמה, לרבות עבודות תחזוקה, התקנות,
                גיזום, שילוט, עבודות חשמל, ניקוי ועבודות נוספות,
                בהתאם לסוג המשימה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            השכרת סל הרמה לפי שעה – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודה עם סל הרמה מתחילה בבדיקת פרטי העבודה.
              יש להבין מה גובה העבודה, מהו סוג המשימה, כמה זמן
              נדרש הציוד ומהם תנאי השטח במקום.
            </p>

            <p>
              בנוסף יש לבחון את נקודת ההצבה, תנאי הגישה והמרחב
              הנדרש כדי לבצע את העבודה בצורה מסודרת ובהתאם
              לתנאים הקיימים בשטח.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              סל הרמה לעבודות בגובה
            </h2>

            <p>
              סל הרמה מאפשר לבצע מגוון עבודות בגובה במקומות שבהם
              עבודה מהקרקע אינה אפשרית או אינה נוחה. בהתאם לסוג
              העבודה ניתן לתכנן את השימוש בציוד לפי תנאי האתר.
            </p>

            <p>
              ניתן להשתמש בסל הרמה לעבודות תחזוקה, התקנה, תיקון,
              גיזום, שילוט, ניקוי ועבודות נוספות הדורשות גישה
              לגובה.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              השכרת סל הרמה לפי שעה לאתרי בנייה ולעסקים
            </h2>

            <p>
              באתרי בנייה, מפעלים, עסקים ומבנים פרטיים יש לעיתים
              צורך בציוד לעבודה בגובה לצורך התקנת ציוד, תחזוקת
              מבנים, שילוט, תאורה ועבודות נוספות.
            </p>

            <p>
              השכרת סל הרמה לפי שעה מאפשרת להתאים את זמן השימוש
              לצורכי העבודה ולמשך המשימה, בהתאם לאפשרויות הציוד
              ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              סל הרמה לגיזום עצים
            </h2>

            <p>
              עבודות גיזום של עצים גבוהים עשויות לדרוש גישה נוחה
              ובטוחה לאזור העבודה. סל הרמה יכול לאפשר הגעה אל
              חלקים גבוהים של העץ בהתאם לתנאי השטח ולמיקום העבודה.
            </p>

            <p>
              לפני תחילת העבודה יש לבדוק את מיקום העץ, תנאי הגישה,
              אפשרויות הצבת הציוד והגובה הנדרש לביצוע המשימה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              השכרת סל הרמה לעבודות תחזוקה והתקנה
            </h2>

            <p>
              סל הרמה מתאים למגוון עבודות תחזוקה והתקנה, כגון
              התקנת שלטים, גופי תאורה, מצלמות, מערכות, ניקוי
              מבנים ועבודות נוספות המבוצעות בגובה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את זמן השכרת הציוד
              ואת מיקום ההצבה כך שיתאימו למשימה ולתנאי האתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להשכרת סל הרמה?
            </h2>

            <p>
              עבודות בגובה דורשות תכנון מוקדם, התאמת ציוד מתאים
              ובדיקה של תנאי השטח. תכנון נכון יכול לסייע בביצוע
              העבודה בצורה מסודרת ובהתאם לדרישות הפרויקט.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון סל ההרמה לסוג
              העבודה, לגובה הנדרש, לזמן השימוש ולתנאי הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – השכרת סל הרמה לפי שעה בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי השכרת סל הרמה
              לעבודות בגובה לקבלנים, חברות, עסקים, אנשי מקצוע
              ולקוחות פרטיים. השירות ניתן בהתאם לסוג העבודה,
              לגובה הנדרש, לזמן השימוש ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים סל הרמה לפי שעה? צרו איתנו קשר, ספרו לנו
              מה גובה העבודה, מה סוג המשימה, כמה זמן נדרש הציוד
              והיכן מתבצעת העבודה, ונבחן עבורכם את פתרון העבודה
              המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Crane_Rental1"
              className="link-right"
            >
השכרת מנוף זרוע            </Link>

            <Link
              to="/Renting_a_basket_crane_for_lifting_a_person"
              className="link-left"
            >
השכרת מנוף סל להרמת אדם            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
